<div class="tooltip-wrapper"
  [ngStyle]="{'transform':tooltipTransform}">
  <app-vi-notification-tooltip class="disabled-reason-tooltip"
    [addAnimation]="false"
    [showArrow]="false"
    [showNotificationDown]="showTooltipDown"
    [notificationText]="message">
  </app-vi-notification-tooltip>
</div>
